import CrudRequest from 'Domain/CrudRequest';
import HttpService from 'Support/services/HttpService';

export default class MessageRequest extends CrudRequest {
  static baseUrl() {
    return '/v1/mensagens-boleto';
  }

  static sendTest(payload) {
    return HttpService.post(
      `${this.baseUrl()}/send-test`,
      payload,
    );
  }
}
